export const FORMLESS_ENTRIES = ['guestAlreadyDone'];
